import { defineStaticService, implementStaticService } from '@wix/static-service'
import type { StaticServiceDefinition, StaticServiceFactoryOpts } from '@wix/static-service'
import { createStyleUtils } from './compStylesOverridesService'
import { StyleUtilsConfig, StyleUtils } from './types'

export type IStyleUtilsDefinition = StaticServiceDefinition<StyleUtils, StyleUtilsConfig>

export const StyleUtilsDefinition = defineStaticService<StyleUtils, StyleUtilsConfig>('viewer-core/style-utils')

export const StyleUtilsService = implementStaticService(
	StyleUtilsDefinition,
	({ config }: StaticServiceFactoryOpts<StyleUtilsConfig>) => createStyleUtils(config)
)
